import CommentItem from "@/components/customerReviews/commentItem";
import { IntlDialog } from "@/components/intlMui";
import { useTranslation } from "@/i18n/client";
import { useEffect, useState } from "react";
import { EXPOSURE_RECORD} from "@/tracks/25347";
import { getInitCommentDetailPage } from "@/apis/dp/service";
import LoadingIcon from "@/components/loading";
interface props{
    skuId:string;
    showDetail:boolean;
    setShowDetail:(v:boolean)=>void;
    detailData:any
}

const ReviewDetail=({skuId,detailData,showDetail,setShowDetail}:props)=>{
    const [isOpenReviewDetail, setIsOpenReviewDetail] = useState<boolean>(false); // 是否打开评论详情弹窗
    const [reviewDetailData, setReviewDetailData] = useState<any>(); // 评论详情数据
    const { t } = useTranslation(); // 切语言
    const [commentOpts,setCommentOpts] =useState<any>();
    const [reportReqParams,setReportReqParams]=useState<any>({});
    const [detailTrack,setDetailTrack]=useState<any>({});
    const commentId = detailData?.commentId??'';
    const parentReplyId = detailData?.parentReplyId??'0';
    const [isLoading,setIsLoading]=useState(true);
    
    // 关闭预览图片视频组件
    
    const closeReviewDetail = () => {
        setIsOpenReviewDetail(false);
        setShowDetail(false);
      };
      // 查看评论详情， 获取评论详情数据
    const showReviewDetail = async () => {

        const res = await getInitCommentDetailPage({ commentId: commentId, parentReplyId: parentReplyId ?? '0', skuId });
        if (res && res.success) {
          setReviewDetailData(res?.data || {});
        }
        setIsLoading(false);
      };
    useEffect(()=>{
        showDetail && setIsOpenReviewDetail(true);
        console.log(detailData,'esffe')
        detailData?.commentId&&showReviewDetail();
        setCommentOpts({
             commentId, // 评论id
            commentNum: detailData?.replyTreeCount, // 评论回复数量
            currentIsUseful: detailData?.usefulVoteResult, // 评论是否有用
            usefulNum: detailData?.usefulVoteCount, // 评论有用数量
            anonymousFlag: detailData?.anonymousFlag, // 评论是否匿名
            currentUserOperation: detailData?.canDelete, // 评论用户操作
            skuId, // 评论商品id
            commentStar: detailData?.commentStar, //8.30评价星级
            verifiedPurchase: detailData?.verifiedPurchase, //8.30购买标识
            commentSource: detailData?.commentSource, //8.30评价来源
            orderId: detailData?.orderId
        })
        setReportReqParams({
            commentId, // 评论id
            targetReplyId:detailData?.targetReplyId, // 评论回复目标id
            parentReplyId:detailData?.parentReplyId, // 评论回复父级id
            toPin: detailData?.userPin, // 评论回复目标pin
            toContent: detailData?.content, // 评论回复目标内容
        })
        setDetailTrack({
            mainskuid:skuId,
            skuId:skuId,
            commentId:commentId,
            pageType:'dpReviewList'
          })
    },[showDetail])
   return(
   <IntlDialog
    onClose={closeReviewDetail}
    open={isOpenReviewDetail}
    title={t("review.reviewDetail")}
    sx={{
      "& .MuiDialog-paper": {
        overflowY: "hidden",
        maxHeight: "800px",
      },
    }}
    content={
      <>
      {isLoading ? (
        <div style={{ width: "100%", minHeight: "min(600px, calc(100vh - 212px))", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <LoadingIcon className="player-loading" />
        </div>
      ):(
        <div className="review-list-wrapper" 
         exptag={"exp|" + EXPOSURE_RECORD.Evaluate_CommentDetail_Expo}
         data-exptag-json-param={JSON.stringify({
           skuId: skuId,
           commentId: commentId,
           mainskuid:skuId,
           orderId:detailData?.orderId
         })}
         data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'>
          <CommentItem
            comment={{ ...reviewDetailData, skuId }}
            showCommentMedia={true}
            showReplyList={true}
            showReply={true}
            isShowScoreStar={true}
            isHandleCommentClick={false}
            commentOpts={commentOpts}
            reportReqParams={reportReqParams}
            trackData={detailTrack}
          />
          <div style={{ width: "100%", height: "55px", lineHeight: "55px", textAlign: "center", color: "#C2C4CC", fontSize: "14px" }}>
            {t("dp.commentSection.end")}
          </div>
        </div>
      )}
      </>
    }
    width={800}
    showButtonAction={false}
  />)
}
export default ReviewDetail